import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from './syntax_white.png'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-[#005152] text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo and Title */}
        <Link to="/" className="flex items-center space-x-2 hover:text-gray-300 transition-colors">
          <img src={logo} alt="Logo" className="h-8 w-8" />
          <div className="text-lg font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            DLSU SYNTAX
          </div>
        </Link>

        {/* Hamburger Menu for Mobile */}
        <button
          className="md:hidden block text-white focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Links */}
        <div
          className={`md:flex space-x-8 items-center ${
            isOpen ? 'block' : 'hidden'
          } absolute md:static top-16 left-0 w-full bg-[#005152] md:w-auto md:space-y-0 space-y-4 p-4 md:p-0`}
        >
          <Link
            to="/"
            className="hover:text-gray-300 block md:inline pl-8"
            style={{ fontFamily: 'Rubik, sans-serif' }}
          >
            Home
          </Link>
          <Link
            to="/reviewers"
            className="hover:text-gray-300 block md:inline"
            style={{ fontFamily: 'Rubik, sans-serif' }}
          >
            Reviewers
          </Link>
          <Link
            to="/syntube"
            className="hover:text-gray-300 block md:inline"
            style={{ fontFamily: 'Rubik, sans-serif' }}
          >
            SYNTube
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
